export const BRAND = {
  name: "Aesthetiq",
  tagline: "Decode your face — AI facial analysis, real scores, a real plan to improve.",
  short: "Instant AI facial analysis in your browser. No app, no iPhone needed.",
  domain: "selfiecheckup.com",
};

export const SITE_URL =
  (typeof window !== "undefined" && window.location.origin) || "https://selfiecheckup.com";
